module.exports = __webpack_public_path__ + "static/media/mission.ff65ab39.svg";